module.exports = __webpack_public_path__ + "img/clouds-moon.87923c24.svg";